import React from "react";
import * as constants from "../../constants/constants.jsx";
import InputText from "../InputText.jsx";
import TranslationText from "../Translation/TranslationText.jsx";
import { useState, useEffect } from "react";
import * as validationConstants from "../../constants/validationConstants.jsx";
import * as regexConstants from "../../constants/regexConstants.jsx";

export function PhysicalCardEntry(props) {
	const [card, setCard] = useState({
		cardPrefix: "",
    cardNumber: ""});

  useEffect(() => {
    const selectedCountry = localStorage.getItem(constants.SELECTED_COUNTRY);
    const cardPrefix = constants.CARD_NUMBER_PREFIX_START + props.initialData.cardPrefixes.find(cp => cp.key === selectedCountry).value;
    setCard({ ...card, cardPrefix: cardPrefix});
  }, []);

  const onChange = (e) => {  
    const { prop, value } = e;
    const sanitizedValue = value.replace(regexConstants.NON_DIGITS_REGEX, '');

    setCard(prevCard => ({
      ...prevCard,
      [prop]: sanitizedValue
    }));

    props.onChange({
      ...card,
      [prop]: sanitizedValue
    });
  };
 
  return (
    <React.Fragment>
      <div className="form-group">
        <div className="form-row rimi-card-back">
          <img className="rimi-card-back-image" src={require("assets/img/rimi-card-back.jpg")} alt="Mans Rimi" />
          <div className="card-numbers">
            <div className="form-col">
              <div className="form-field">
                <InputText
                  prop="cardPrefix"
                  className="form-field__input"
                  value={card.cardPrefix}
                  onChange={onChange}
                  maxLength={validationConstants.CARD_PREFIX_MAX_LENGTH}
                  type="tel"
                />
              </div>
            </div>
            <div className="form-col">
              <div className="form-field">
                <InputText
                  prop="cardNumber"
                  className="form-field__input"
                  value={card.cardNumber}
                  onChange={onChange}
                  maxLength={validationConstants.CARD_NUMBER_MAX_LENGTH}
                  type="tel"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="sublabel error-msg show">
          <span>
            {
              (props.errorMessage?.length > 0)
                ? <TranslationText text={props.errorMessage} />
                : null
            }
          </span>
        </div>
      </div>
    </React.Fragment>
  );
}
